<div
    (keydown.enter)="onItemClicked()"
    (keydown.space)="onItemClicked()"
    (click)="onItemClicked()"
    [attr.aria-checked]="switchControl()?.value"
    role="switch"
    tabindex="0"
    class="ap-switch-container"
    data-testid="list-item-switch-container"
>
    <ng-content></ng-content>
    @if (switchControl()) {
        <ap-switch
            class="ap-switch-case"
            [attr.aria-hidden]="true"
            [formControl]="switchControl()"
            data-testid="list-item-switch"
            [nonInteractive]="!switchControl().disabled"
        ></ap-switch>
    }
</div>
